import { usageTrackerActions } from 'usage-tracker-redux';
const trackPageView = props => dispatch => {
  dispatch(usageTrackerActions.track('pageView', Object.assign({}, props)));
};
const trackInteraction = props => dispatch => {
  dispatch(usageTrackerActions.track('interaction', Object.assign({}, props)));
};
export const TrackerActions = {
  trackPageView,
  trackInteraction
};